import _ from 'lodash';
import {
  FETCH_NOTIFICATIONS_SUCCEED, FETCH_USER_NOTIFICATIONS_SUCCEED,
  CHECKED_USER_NOTIFICATIONS_SUCCEED,
  CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED,
  DELETE_ALL_USER_NOTIFICATIONS_SUCCEED,
  DELETE_USER_NOTIFICATIONS_SUCCEED,
  FETCH_MARKED_NOTIFICATIONS_SUCCEED,
} from '../actions/notification/action_types';

export default (state = {
  listNotifications: [],
  userNotifications: [],
  markedNotifications: [],
}, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_SUCCEED:
      const newArr = [];
      _.map(action.params.data, (value, index) => {
        value.id = index;
        newArr.push(value);
      });
      return {
        ...state,
        listNotifications: newArr,
      };
    case FETCH_USER_NOTIFICATIONS_SUCCEED:
      const newArrUser = [];
      _.map(action.params.data, (value, index) => {
        value.id = index;
        newArrUser.push(value);
      });
      return {
        ...state,
        userNotifications: newArrUser,
      };
    case CHECKED_USER_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case CHECKED_ALL_USER_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case DELETE_ALL_USER_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case DELETE_USER_NOTIFICATIONS_SUCCEED:
      return {
        ...state,
      };
    case FETCH_MARKED_NOTIFICATIONS_SUCCEED:
      const newArrMarked = [];
      _.map(action.params.data, (value, index) => {
        value.id = index;
        newArrMarked.push(value);
      });
      return {
        ...state,
        markedNotifications: newArrMarked,
      };
    default:
      return {
        ...state,
      };
  }
};
